// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"a66eb328","239":"e39fb35b","355":"b5e33dae","361":"d33c1d88","455":"98db480b","821":"f2cc7ce4","977":"00323907"}[chunkId] + ".chunk.js";
};